import {Component, EventEmitter, OnInit, Output} from '@angular/core';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'capture-image-modal',
    templateUrl: './capture-image-modal.component.html',
    styleUrls: ['capture-image-modal.component.scss']
})

export class CaptureImageModalComponent implements OnInit {
    @Output() onClose = new EventEmitter();
    image = '';
    croppedImageFile = '';
    disabledSave = false;
    stream = null;

    constructor() {}

    ngOnInit() {
        setTimeout(() => {
            const player = document.getElementById('player');
            const canvas = document.getElementById('canvas');
            const context = (<any>canvas).getContext('2d');
            const captureButton = document.getElementById('capture');

            const constraints = {
                video: true
            };

            captureButton.addEventListener('click', () => {
                if(navigator.getUserMedia || (<any>navigator).webkitGetUserMedia || (<any>navigator).mozGetUserMedia || (<any>navigator).msGetUserMedia) {
                    // Draw the video frame to the canvas.
                    context.drawImage(player, 0, 0, (<any>canvas).width, (<any>canvas).height);
                    this.image = (<any>canvas).toDataURL();
                }
            });

            // Attach the video stream to the video element and autoplay.
            navigator.mediaDevices.getUserMedia(constraints).then(stream => {
                this.stream = stream;
                (<any>player).srcObject = stream;
            });
        }, 1000);
    }

    hideModal(close) {
        if(!close) {
            this.disabledSave = true;
            fetch(this.croppedImageFile).then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], 'Webcam Image');
                    this.onClose.emit(file);
                });
        } else
            this.onClose.emit(null);

        this.stream.getTracks()[0].stop();
    }

    imageCropped(event) {
        this.croppedImageFile = event.base64;
    }

    loadImageFailed(event) {
        toastr.error('Unknown Error');
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/capture-image-modal/capture-image-modal.component.ts